import type { Story } from "@theirstory/common/api_types/backend";

export type GeneratedContentType = "description" | "index";
export type ContentStatus = "ready" | "queued" | "missing";

export const getMissingRequirements = (story: Story) => {
  const missingRequirements: string[] = [];

  if (!story.description?.trim()) {
    missingRequirements.push("Description");
  }

  if (!story.indexes?.length) {
    missingRequirements.push("Index");
  }

  return missingRequirements;
};

export const getContentStatus = (
  story: Story,
  type: GeneratedContentType,
  queuedContent: GeneratedContentType[]
): ContentStatus => {
  const isReady = type === "description" ? Boolean(story.description?.trim()) : Boolean(story.indexes?.length);
  if (isReady) return "ready";
  return queuedContent.includes(type) ? "queued" : "missing";
};
